export default {
  apiKey: null,
  apiUrl: 'https://api.vuics.com/latest',
}
